// extracted by mini-css-extract-plugin
export default {"componentHolder":"DeliverCostContainer_componentHolder__aMEv6","selectOptionsearch":"DeliverCostContainer_selectOptionsearch__uL8rC"};